import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LogoutButton: React.FC = () => {
  const { logout } = useAuth0();
  const [hover, setHover] = useState(false);

  return (
    <button
      style={hover ? { ...styles.button, ...styles.buttonHover } : styles.button}
      onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      Log Out
    </button>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  button: {
    backgroundColor: "#0056b3", // Deep blue to match the theme
    color: "#fff",
    padding: "12px 24px",
    fontSize: "16px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "0.3s ease-in-out",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    marginTop: "10px",
  },
  buttonHover: {
    backgroundColor: "#003d80", // Darker blue on hover
    transform: "scale(1.05)",
  },
};

export default LogoutButton;
